import { useDidUpdateEffect } from "2g-hooks";
import { useDataLoader } from "2g-hooks/fetch";

import { DATA } from "b2b/api/paths";

export default function useZadostiGroups({ datumOd, datumDo, stav }) {
  const loader = useDataLoader({
    url: DATA.dataZadostiSumar(),
    method: "post",
    payload: {
      datumOd: datumOd.getTime(),
      datumDo: datumDo.getTime(),
      stav
    }
  });

  useDidUpdateEffect(() => {
    loader.load();
  }, [datumOd, datumDo, stav]);

  return loader;
}
